exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ignite-test-component__container___14mTG {\n  font-family: \"Raleway\", \"HelveticaNeue\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  margin: 0 auto;\n  text-align: center;\n  width: 70%;\n}\n\n.ignite-test-component__container___14mTG hr {\n  border-top: 1px solid #8C8B8B;\n  margin: 50px 0;\n}\n\n.ignite-test-component__container___14mTG h4 {\n  text-align: left;\n}\n", ""]);

// exports
exports.locals = {
	"grey": "#8C8B8B",
	"container": "ignite-test-component__container___14mTG"
};


//////////////////
// WEBPACK FOOTER
// ./src/styles/ignite-test-component.css
// module id = 88
// module chunks = 0